/** The header a `dev` route checks against `DEV_WEBHOOK_SECRET`. */
export const DEV_SECRET_HEADER = 'x-becca-dev-secret';
const isRouteDef = (v) => typeof v === 'object' && v !== null && 'method' in v && 'path' in v;
/**
 * A flat (`{ name: def }`) or grouped (`{ group: { name: def } }`) table as `['group.name', def]` pairs —
 * for fakes, clients and route-coverage checks.
 */
export function flattenRoutes(table) {
    return Object.entries(table).flatMap(([key, value]) => isRouteDef(value)
        ? [[key, value]]
        : Object.entries(value).map(([name, def]) => [`${key}.${name}`, def]));
}
/** Fill `:param` segments: `buildPath('/g/holds/:id', { id })`. Values are URI-encoded. */
export function buildPath(path, params = {}) {
    return path.replace(/:([A-Za-z_][A-Za-z0-9_]*)/g, (_, name) => {
        const value = params[name];
        if (value === undefined)
            throw new Error(`Missing path parameter "${name}" for ${path}`);
        return encodeURIComponent(String(value));
    });
}
/** Turn a query object into `?a=1&b=2`, skipping undefined and null. */
export function buildQuery(query) {
    if (!query)
        return '';
    const parts = [];
    for (const [key, value] of Object.entries(query)) {
        if (value === undefined || value === null)
            continue;
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    }
    return parts.length ? `?${parts.join('&')}` : '';
}
/** `true` when a staff member with this venue role (and platform role) may call this route. */
export function roleAllowed(route, role, platformRole = null) {
    if (platformRole === 'helix_admin')
        return true;
    if (!role)
        return false;
    if (route.roles)
        return route.roles.includes(role);
    return route.method === 'GET' || role !== 'viewer';
}
//# sourceMappingURL=routes.js.map